"use client";

import { memo, useState } from "react";

import CardLayout from "@/components/common/cardLayout";
import ErrorMessage from "@/components/common/errorMessage";

import { TimePeriod } from "../types";
import SearchAppearancesContent from "./components/SearchAppearancesContent";
import Skeleton from "./components/skeleton";
import { useSearchAppearances } from "./query";

const SearchAppearances = () => {
  const [timePeriod, setTimePeriod] = useState<TimePeriod>("90");
  const { data, isLoading, isError } = useSearchAppearances(timePeriod);

  if (isLoading) {
    return (
      <CardLayout containerClassName="!mt-0" className="!p-6">
        <Skeleton />
      </CardLayout>
    );
  }

  if (isError || !data || "error" in data) {
    return (
      <CardLayout containerClassName="!mt-0" className="!p-6">
        <ErrorMessage text="Failed to load search appearances data" />
      </CardLayout>
    );
  }

  const searchData = data as {
    totalSearches: number;
    changeSinceLastWeek: string;
    timePeriod: number;
    searchKeywords: Array<{ keyword: string; keywordCount: number }>;
    searchTrends: Array<{ period: string; totalCount: number }>;
  };

  return (
    <CardLayout
      containerClassName="!mt-0"
      className="rounded-xl border border-[rgba(232,235,240,0.5)] bg-white px-3 py-4 shadow-[0_10px_45px_0_rgba(0,0,0,0.03)] md:!p-4"
    >
      <SearchAppearancesContent
        data={searchData}
        timePeriod={timePeriod}
        onTimePeriodChange={setTimePeriod}
      />
    </CardLayout>
  );
};

export default memo(SearchAppearances);
